module.exports = __webpack_public_path__ + "img/page_1_left.adf70ab8.jpg";